import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pwa-install',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './pwa-install.component.html',
  styleUrls: ['./pwa-install.component.css']
})
export class PwaInstallComponent implements OnInit {

  showInstallButton = false;
  installEvent: any;  // beforeinstallprompt მოვლენა

  constructor() { }
  ngOnInit(): void {
    window.addEventListener('beforeinstallprompt', (event: any) => {
      console.log(event)
      event.preventDefault();
      this.installEvent = event;
      this.showInstallButton = true;
    });
}

  installPwa(): void {
    if (this.installEvent) {
      this.installEvent.prompt();  // PWA ინსტალაციის ბატონის გაშვება
      this.installEvent.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the PWA installation');
        } else {
          console.log('User dismissed the PWA installation');
        }
        this.installEvent = null;  // მოიშორეთ ინსტალაციის მოვლენა
        this.showInstallButton = false;  // დამალეთ ბატონი
      });
    }
  }

  close(): void {
    this.showInstallButton = false;  // დამალეთ ბატონი
  }
}